import { useMemo } from "react";
import { getPermissions } from "../../utils/app.utils";
import { MENUS_FIRST } from "../../constants/menu";

export type MenuPermission = {
  isView: boolean;
  isCreate: boolean;
  isApporve: boolean;
};

/**
 * อ่านสิทธิ์ของเมนูโอนมรดกจากลิสต์เมนูใน PERMISSION โดยตรง ไม่พึ่ง activeMenu
 *
 * ทำไมไม่ใช้ isView()/isApporve() จาก utils/permission.utils เหมือนหน้าอื่น:
 * PrivateRoute (App.tsx) เขียน activeMenu ลง localStorage ระหว่าง render และ render รอบแรก
 * menuPermissions ยังเป็น [] ทำให้ _.find คืน undefined จากนั้น JSON.stringify ตัด key
 * activeMenu ทิ้งทั้ง key — สิทธิ์จึงหายไปชั่วคราว ปุ่มจางจนกว่าจะ render รอบใหม่หรือ reload
 *
 * ลิสต์เมนู (key ตัวเลข) ไม่ได้ถูกแก้ในจังหวะนั้น จึงอ่านจากตรงนั้นแล้วเทียบด้วย menuFirstKey
 * ของหน้านี้เอง ได้ค่าที่ถูกตั้งแต่ render แรก
 */
export const useMenuPermission = (): MenuPermission =>
  useMemo(() => {
    const permissions: any = getPermissions() || {};
    const { activeMenu, ...menus } = permissions;

    const ownMenu: any = Object.values(menus).find(
      (menu: any) => menu?.menuFirstKey === MENUS_FIRST.INHERITANCE_TRANSFER
    );

    // activeMenu เป็นทางสำรอง เผื่อ PERMISSION ถูกเก็บในรูปที่ไม่มีลิสต์เมนู
    const source: any = ownMenu || activeMenu || {};

    return {
      isView: !!source.isView,
      isCreate: !!source.isCreate,
      isApporve: !!source.isApporve,
    };
    // สิทธิ์ถูก cache ตอน login ไม่เปลี่ยนระหว่างอยู่ในหน้า อ่านครั้งเดียวพอ
  }, []);
